import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c39db86"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "center"
}
const _hoisted_2 = {
  key: 1,
  class: "center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-h5 font-weight-bold" }, "Detalle de la inscripción", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Lista:", -1))
const _hoisted_5 = { class: "text-h6 font-weight-bold text-primary" }
const _hoisted_6 = {
  key: 1,
  class: "text-grey-darken-1 text-center"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold" }, "Estado de pago:", -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "text-h6 font-weight-bold text-primary" }
const _hoisted_11 = {
  key: 1,
  class: "text-grey-darken-1 text-center"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold" }, "Estado de pago:", -1))

import { ref, onMounted, watch } from "vue";
import ModalSuccess from "../Commons/ModalSuccess.vue";
import ModalError from "../Commons/ModalError.vue";
import LoadingGandalf from "../Commons/LoadingGandalf.vue";
import { getIncripcionById } from "@/services/InscripcionesService";
import { InscripcionTorneoCreadoDTO, Torneo } from "@/interfaces/Torneo";
import ModalLista from "./ModalLista.vue";
import {
  CrearListaTorneoRequestDTO,
  ListaTorneoRequestDTO,
  ModificarListaTorneoRequestDTO,
  RequesListaDTO,
} from "@/interfaces/Lista";
import {
  getListasByInscripcion,
  getlistaTorneo,
  modificarListaTorneo,
  subirListaTorneo,
} from "@/services/ListasService";
import { ArmyDTO } from "@/interfaces/Army";
import { ListaDTO } from "@/interfaces/Usuario";
import ModalModificarLista from "./ModalModificarLista.vue";
import ModalEnviarLista from "./ModalEnviarLista.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalInscripcion',
  props: {
    idInscripcion: {},
    idUsuario: {},
    idTorneo: {},
    idOrganizador: {}
  },
  emits: ["close", "eliminar-inscripcion"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const show = ref(true);
const showSuccessModalEliminar = ref<boolean>(false);
const showErrorModal = ref<boolean>(false);

const isLoading = ref(true);
const isRegistering = ref(false);

const inscripcionData = ref<InscripcionTorneoCreadoDTO>({
  idInscripcion: 0,
  idUsuario: 0,
  torneo: {
    idTorneo: 0,
    idUsuario: 0,
    nombreTorneo: "",
    descripcionTorneo: "",
    fechaInicioTorneo: "",
    fechaFinTorneo: "",
    precioTorneo: 0,
    numeroPartidas: 0,
    puntosTorneo: 0,
    estadoTorneo: "ESPERANDO",
    lugarTorneo: "",
    esPrivadoTorneo: false,
    idRangoTorneo: 0,
    esMatchedPlayTorneo: false,
    fechaEntregaListas: "",
    fechaFinInscripcion: "",
    basesTorneo: "",
    cartelTorneo: "",
    metodosPago: [],
    horaInicioTorneo: "",
    horaFinTorneo: "",
    tieneBases: false,
    inicioInscripciones: "",
    listasPorJugador: 0,
    tipoTorneo: "Individual",
  },
  idTorneo: 0,
});
const torneo = ref<Torneo>({
  idTorneo: 0,
  idUsuario: 0,
  nombreTorneo: "",
  descripcionTorneo: "",
  fechaInicioTorneo: "",
  fechaFinTorneo: "",
  precioTorneo: 0,
  numeroPartidas: 0,
  puntosTorneo: 0,
  estadoTorneo: "ESPERANDO",
  lugarTorneo: "",
  esPrivadoTorneo: false,
  idRangoTorneo: 0,
  esMatchedPlayTorneo: false,
  fechaEntregaListas: "",
  fechaFinInscripcion: "",
  basesTorneo: "",
  cartelTorneo: "",
  metodosPago: [],
  horaInicioTorneo: "",
  horaFinTorneo: "",
  tieneBases: false,
  inicioInscripciones: "",
  listasPorJugador: 0,
  tipoTorneo: "Individual",
});
const currentInscripcionId = ref<number>();
const currentIdLista = ref<number>();

const showVerListaModal = ref<boolean>(false);
const showModificarListaModal = ref<boolean>(false);
const showEnviarListaModal = ref<boolean>(false);
const hasLista = ref<boolean>(false);
const listaText = ref<string>("");
const ejercito = ref<ArmyDTO>({
  name: "",
  band: "",
});
const showSuccessModalLista = ref<boolean>(false);
const showErrorModalLista = ref<boolean>(false);
const idLista = ref<number | null>();
const showLista = ref<boolean>(false);
const showListaPorIndex = ref<Record<number, boolean>>({});
const listaBase64 = ref<string | null>();

const currentListaData = ref<string | null>();
const currentNombreEjercito = ref<string | null>();

const listasPorJugador = ref<ListaDTO[]>([]);

watch(
  () => showSuccessModalLista.value,
  (newValue, oldValue) => {
    if (oldValue && !newValue) {
      recargarPagina();
    }
  }
);

const recargarPagina = () => {
  window.location.reload();
};

const handleVerLista = async (idInscripcion: number) => {
  currentInscripcionId.value = idInscripcion;
  idLista.value = inscripcionData.value?.idLista;

  if (inscripcionData.value?.bando) hasLista.value = true;
  if (idLista.value)
    await handleModificarListaMasDeUnaListaPorJugador(idLista.value);
  else {
    await verLista();
  }
};

const handleEnviarListaMasDeUnaListaPorJugador = async (
  idInscripcion: number
) => {
  currentInscripcionId.value = idInscripcion;
  showEnviarListaModal.value = true;
};

const handleModificarListaMasDeUnaListaPorJugador = async (id: number) => {
  currentIdLista.value = id;
  showModificarListaModal.value = true;
};

const toggleLista = async () => {
  if (!props.idTorneo || !props.idUsuario) {
    console.error("Faltan datos necesarios: idTorneo o idUsuario.");
    return;
  }

  showLista.value = !showLista.value;
  isLoading.value = true;

  const requestLista: ListaTorneoRequestDTO = {
    idTorneo: props.idTorneo,
    idUsuario: props.idUsuario,
  };
  try {
    const response = await getlistaTorneo(requestLista);
    listaBase64.value = response.data.listaData;
    ejercito.value.name = response.data.ejercito;
    ejercito.value.band = response.data.bando;
  } catch (error) {
    console.error("Error al recuperar la lista.");
  } finally {
    isLoading.value = false;
  }
};

const toggleListaMasDeUna = async (
  index: number,
  listaData: string,
  nombreEjercito: string
) => {
  if (!listaData) {
    console.error("Faltan el data de la lista");
    return;
  }
  showListaPorIndex.value[index] = !showListaPorIndex.value[index];

  currentListaData.value = listaData;
  currentNombreEjercito.value = nombreEjercito;

  if (!showListaPorIndex.value[index]) {
    currentListaData.value = "";
    currentNombreEjercito.value = "";
  }
};

const verLista = async () => {
  showVerListaModal.value = true;
};

const handleEnviarLista = async (newLista: RequesListaDTO) => {
  listaText.value = newLista.listaData;
  ejercito.value = newLista.ejercito;
  await enviarLista(newLista);
};

const enviarLista = async (newLista: RequesListaDTO) => {
  if (currentInscripcionId.value && props.idUsuario && props.idTorneo) {
    isRegistering.value = true;
    const requestLista: CrearListaTorneoRequestDTO = {
      idInscripcion: currentInscripcionId.value,
      listaData: newLista.listaData,
      ejercito: newLista.ejercito,
      idUsuario: props.idUsuario,
      idTorneo: props.idTorneo,
    };

    try {
      await subirListaTorneo(requestLista);
      showSuccessModalLista.value = true;
    } catch {
      isRegistering.value = false;
      showErrorModalLista.value = true;
    } finally {
      isRegistering.value = false;
      showVerListaModal.value = false;
      showEnviarListaModal.value = false;
    }
  }
};

const handleModificarLista = async (newLista: RequesListaDTO) => {
  ejercito.value = newLista.ejercito;
  listaText.value = newLista.listaData;
  await modificarLista(newLista);
};

const modificarLista = async (newLista: RequesListaDTO) => {
  isRegistering.value = true;
  if (currentIdLista.value == null) {
    return;
  }
  const requestLista: ModificarListaTorneoRequestDTO = {
    listaData: newLista.listaData,
    idLista: currentIdLista.value,
    ejercito: newLista.ejercito,
    idUsuario: props.idUsuario,
    idTorneo: props.idTorneo,
  };
  try {
    await modificarListaTorneo(requestLista);
    showSuccessModalLista.value = true;
  } catch {
    isRegistering.value = false;
    showErrorModalLista.value = true;
  } finally {
    isRegistering.value = false;
    showVerListaModal.value = false;
    showModificarListaModal.value = false;
  }
};

const eliminarInscripcion = async (idInscripcion: number) => {
  emit("eliminar-inscripcion", idInscripcion);
  show.value = false;
  emit("close");
};

const close = () => {
  show.value = false;
  emit("close");
};

onMounted(async () => {
  try {
    isLoading.value = true;

    const response = await getIncripcionById(props.idInscripcion);
    inscripcionData.value = response.data;
    if (inscripcionData.value) torneo.value = inscripcionData.value.torneo;

    if (
      torneo.value != null &&
      inscripcionData.value != null &&
      torneo.value?.listasPorJugador > 1
    ) {
      const responseTorneo = await getListasByInscripcion(
        inscripcionData.value.idInscripcion
      );
      listasPorJugador.value = responseTorneo.data;
    }
  } catch (error) {
    console.error("Error al obtener datos de la inscripcion:", error);
  } finally {
    isLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_list_item_content = _resolveComponent("v-list-item-content")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(LoadingGandalf)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_dialog, {
            modelValue: show.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((show).value = $event)),
            "max-width": "800px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { elevation: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "modal-title d-flex align-center justify-space-between" }, {
                    default: _withCtx(() => [
                      _hoisted_3,
                      _createVNode(_component_v_btn, {
                        icon: "",
                        onClick: close,
                        class: "close-button"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { color: "grey darken-1" }, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-close")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  (torneo.value.listasPorJugador == 1)
                    ? (_openBlock(), _createBlock(_component_v_card_text, {
                        key: 0,
                        class: "px-6 py-4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, { class: "list-item-title" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        color: "primary",
                                        class: "mr-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("mdi-file-document")
                                        ]),
                                        _: 1
                                      }),
                                      _hoisted_4,
                                      _createTextVNode("  " + _toDisplayString(inscripcionData.value?.estadoLista), 1)
                                    ]),
                                    _: 1
                                  }),
                                  (inscripcionData.value?.listaData)
                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                        key: 0,
                                        color: "primary",
                                        variant: "tonal",
                                        block: "",
                                        onClick: toggleLista
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, { left: "" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("mdi-eye")
                                            ]),
                                            _: 1
                                          }),
                                          _createTextVNode(_toDisplayString(showLista.value ? "Ocultar lista" : "Ver lista"), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (new Date(torneo.value!.fechaFinTorneo) >= new Date())
                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                        key: 1,
                                        color: "primary",
                                        block: "",
                                        variant: "tonal",
                                        class: "elevated-btn",
                                        onClick: _cache[0] || (_cache[0] = ($event: any) => (handleVerLista(inscripcionData.value?.idInscripcion)))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, { left: "" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("mdi-mail")
                                            ]),
                                            _: 1
                                          }),
                                          _createTextVNode(" Enviar / Modificar Lista ")
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_divider, { class: "mt-3 mb-1" }),
                              _createVNode(_component_v_expand_transition, null, {
                                default: _withCtx(() => [
                                  (showLista.value)
                                    ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item_content, null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("h3", _hoisted_5, _toDisplayString(inscripcionData.value?.ejercito), 1),
                                              _createVNode(_component_v_divider, { class: "my-3" }),
                                              (listaBase64.value)
                                                ? (_openBlock(), _createBlock(_component_v_img, {
                                                    key: 0,
                                                    src: listaBase64.value,
                                                    alt: "Lista de ejército",
                                                    "max-width": "100%",
                                                    class: "rounded-img",
                                                    contain: ""
                                                  }, null, 8, ["src"]))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_6, " No hay lista disponible "))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, { class: "list-item-title" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        color: inscripcionData.value?.esPago === 'SI' ? 'green' : 'red',
                                        class: "mr-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("mdi-credit-card")
                                        ]),
                                        _: 1
                                      }, 8, ["color"]),
                                      _hoisted_7,
                                      _createVNode(_component_v_chip, {
                                        color: inscripcionData.value?.esPago === 'SI' ? 'green' : 'red',
                                        dark: "",
                                        class: "ml-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(inscripcionData.value?.esPago === "SI" ? "Pagado" : "No pagado"), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["color"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (new Date(torneo.value!.fechaFinTorneo) >= new Date())
                                ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        color: "red-darken-3",
                                        variant: "tonal",
                                        block: "",
                                        class: "elevated-btn",
                                        onClick: _cache[1] || (_cache[1] = ($event: any) => (eliminarInscripcion(_ctx.idInscripcion!)))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, { left: "" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("mdi-delete")
                                            ]),
                                            _: 1
                                          }),
                                          _createTextVNode(" Darse de baja del torneo ")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_v_card_text, {
                        key: 1,
                        class: "px-6 py-4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(torneo.value.listasPorJugador, (index) => {
                                return (_openBlock(), _createBlock(_component_v_list_item, { key: index }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, { class: "list-item-title" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, {
                                          color: "primary",
                                          class: "mr-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("mdi-file-document")
                                          ]),
                                          _: 1
                                        }),
                                        _createElementVNode("strong", null, "Lista " + _toDisplayString(index) + ":", 1),
                                        _createTextVNode("  "),
                                        (listasPorJugador.value[index - 1])
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(listasPorJugador.value[index - 1].estadoLista), 1))
                                          : (_openBlock(), _createBlock(_component_v_chip, {
                                              key: 1,
                                              color: "red",
                                              dark: "",
                                              class: "ml-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" NO ENTREGADA ")
                                              ]),
                                              _: 1
                                            }))
                                      ]),
                                      _: 2
                                    }, 1024),
                                    (listasPorJugador.value[index - 1]?.listaData)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                          (listasPorJugador.value[index - 1]?.listaData)
                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 0,
                                                color: "primary",
                                                variant: "tonal",
                                                block: "",
                                                onClick: ($event: any) => (
                    toggleListaMasDeUna(
                      index,
                      listasPorJugador.value[index - 1].listaData!,
                      listasPorJugador.value[index - 1].ejercito!
                    )
                  )
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_icon, { left: "" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("mdi-eye")
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createTextVNode(" " + _toDisplayString(showLista.value ? "Ocultar lista" : "Ver lista"), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_v_expand_transition, null, {
                                            default: _withCtx(() => [
                                              (showListaPorIndex.value[index])
                                                ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_list_item_content, null, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("h3", _hoisted_10, _toDisplayString(currentNombreEjercito.value), 1),
                                                          _createVNode(_component_v_divider, { class: "my-3" }),
                                                          (listasPorJugador.value[index - 1]?.listaData)
                                                            ? (_openBlock(), _createBlock(_component_v_img, {
                                                                key: 0,
                                                                src: listasPorJugador.value[index - 1].listaData,
                                                                alt: "Lista de ejército",
                                                                "max-width": "100%",
                                                                class: "rounded-img",
                                                                contain: ""
                                                              }, null, 8, ["src"]))
                                                            : (_openBlock(), _createElementBlock("p", _hoisted_11, " No hay lista disponible "))
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          (new Date(torneo.value!.fechaFinTorneo) >= new Date())
                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 1,
                                                color: "primary",
                                                block: "",
                                                variant: "tonal",
                                                class: "elevated-btn",
                                                onClick: ($event: any) => (
                    handleModificarListaMasDeUnaListaPorJugador(
                      listasPorJugador.value[index - 1].idLista!
                    )
                  )
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_icon, { left: "" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("mdi-mail")
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createTextVNode(" Modificar ")
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                          (new Date(torneo.value!.fechaFinTorneo) >= new Date())
                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 0,
                                                color: "primary",
                                                block: "",
                                                variant: "tonal",
                                                class: "elevated-btn",
                                                onClick: _cache[2] || (_cache[2] = ($event: any) => (
                    handleEnviarListaMasDeUnaListaPorJugador(
                      inscripcionData.value.idInscripcion
                    )
                  ))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_icon, { left: "" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("mdi-mail")
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createTextVNode(" Enviar ")
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true)
                                        ])),
                                    _createVNode(_component_v_divider, { class: "mt-3 mb-1" })
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128)),
                              _createVNode(_component_v_list_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, { class: "list-item-title" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        color: inscripcionData.value?.esPago === 'SI' ? 'green' : 'red',
                                        class: "mr-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("mdi-credit-card")
                                        ]),
                                        _: 1
                                      }, 8, ["color"]),
                                      _hoisted_13,
                                      _createVNode(_component_v_chip, {
                                        color: inscripcionData.value?.esPago === 'SI' ? 'green' : 'red',
                                        dark: "",
                                        class: "ml-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(inscripcionData.value?.esPago === "SI" ? "Pagado" : "No pagado"), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["color"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (new Date(torneo.value!.fechaFinTorneo) >= new Date())
                                ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        color: "red-darken-3",
                                        variant: "tonal",
                                        block: "",
                                        class: "elevated-btn",
                                        onClick: _cache[3] || (_cache[3] = ($event: any) => (eliminarInscripcion(_ctx.idInscripcion!)))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, { left: "" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("mdi-delete")
                                            ]),
                                            _: 1
                                          }),
                                          _createTextVNode(" Darse de baja del torneo ")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModalEliminar.value,
      message: "Inscripción eliminada.",
      "onUpdate:isVisible": _cache[5] || (_cache[5] = ($event: any) => (showSuccessModalEliminar.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "No se ha podido actualizar la inscripción. Contacta con el administrador.",
      "onUpdate:isVisible": _cache[6] || (_cache[6] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"]),
    (currentInscripcionId.value != undefined && currentInscripcionId.value != null)
      ? (_openBlock(), _createBlock(ModalLista, {
          key: 2,
          isVisible: showVerListaModal.value,
          hasLista: hasLista.value,
          idInscripcion: currentInscripcionId.value,
          "onUpdate:isVisible": _cache[7] || (_cache[7] = ($event: any) => (showVerListaModal.value = $event)),
          onEnviarLista: handleEnviarLista,
          onModificarLista: handleModificarLista
        }, null, 8, ["isVisible", "hasLista", "idInscripcion"]))
      : _createCommentVNode("", true),
    (showEnviarListaModal.value)
      ? (_openBlock(), _createBlock(ModalEnviarLista, {
          key: currentInscripcionId.value,
          isVisible: showEnviarListaModal.value,
          "onUpdate:isVisible": _cache[8] || (_cache[8] = ($event: any) => ((showEnviarListaModal).value = $event)),
          idInscripcion: currentInscripcionId.value!,
          idUsuario: props.idUsuario,
          idTorneo: props.idTorneo,
          hasLista: false,
          onEnviarLista: enviarLista,
          onModificarLista: modificarLista
        }, null, 8, ["isVisible", "idInscripcion", "idUsuario", "idTorneo"]))
      : _createCommentVNode("", true),
    _createVNode(ModalModificarLista, {
      isVisible: showModificarListaModal.value,
      idLista: currentIdLista.value!,
      "onUpdate:isVisible": _cache[9] || (_cache[9] = ($event: any) => (showModificarListaModal.value = $event)),
      onModificarListaMasDeUna: modificarLista
    }, null, 8, ["isVisible", "idLista"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModalLista.value,
      message: "Lista enviada con éxito.",
      "onUpdate:isVisible": _cache[10] || (_cache[10] = ($event: any) => (showSuccessModalLista.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModalLista.value,
      message: "No se ha podido enviar la lista. Contacta con el administrador.",
      "onUpdate:isVisible": _cache[11] || (_cache[11] = ($event: any) => (showErrorModalLista.value = $event))
    }, null, 8, ["isVisible"])
  ], 64))
}
}

})